import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewYearAlert',
  setup(__props) {

const opened = ref(false);

const route = useRoute();
const duration = (route.name === 'Catalog' || route.name === 'Products') ? 5000 : 10000;
const dateLimit = new Date('2026-01-12T00:00:00') > new Date();

setTimeout(() => {
  if (route.name !== 'GetCard' && dateLimit) {
    opened.value = true;
  }
}, duration);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    modelValue: opened.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((opened).value = $event)),
    close: "",
    "content-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(BaseCard, { class: "m_pa16 m_bg-white m_flex m_flex-column m_flex-grow1 m_hov-elevation-1 m_hov-border-none" }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("p", { class: "m_h2 m_mb16" }, " Успейте сделать заказ до 17.12 и сможете забрать заказ до нового года. ", -1),
          _createElementVNode("p", { class: "m_h4" }, " Заказы сделанные после 17.12 будут обработаны уже после нового года ", -1)
        ])),
        _: 1,
        __: [1]
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})